$.fn.PostShare = function(button) {
  let self = this

  if (self.data('post-share')) {
    return self.data('post-share')
  }

  self.open = function() {
    self.css('top', 'auto')
    button.after(self.css({
      marginTop: $.mlmi.mobile.isMobile ? '20px' : '15px',
      left: $.mlmi.mobile.isMobile ? '10px' : ((button.offset().left - parseFloat(button.closest('.container').css('padding-left')) + 12) + 'px'),
    }))
    requestAnimationFrame(function() {
      self.attr('aria-hidden', 'false')
      $(document).on('click', self.clicked_outside)
    })
  }

  self.close = function() {
    self.attr('aria-hidden', 'true')
    $(document).off('click', self.clicked_outside)
  }

  self.copy_link = function() {
    self.find('.post-share__action--copy-link').width(self.find('.post-share__action--copy-link').width())
    self.find('textarea').val(window.location.href).focus().select()
    document.execCommand("Copy")
    self.find('.post-share__action--copy-link span').text(fondationsaintlo_l10n.COPIED_LINK)
    return false
  }

  self.clicked_outside = function(e) {
    if (!$(e.target).hasClass('.post-share') && !$(e.target).closest('.post-share').length) {
      button.close()
      self.close()
    }
  }

  return function() {
    self.find('.post-share__action--copy-link').on('click', self.copy_link)
    self.find('.post-share__close').on('click', function() {
      button.close()
      self.close()
    })
    self.data('post-share', self)
    return self
  }()
}

$.fn.PostShare_Button = function() {
  let self = this

  if (self.data('post-share-button')) {
    return self.data('post-share-button')
  }

  self.share_box = $('.post-share').PostShare(self)

  self.button_clicked = function() {
    if (self.share_box.attr('aria-hidden') == 'true') {
      self.attr('aria-expanded', 'true')
      self.share_box.open()
    }
  }

  self.close = function() {
    self.attr('aria-expanded', 'false')
  }

  return function() {
    self.on('click', self.button_clicked)
    self.data('post-share-button', self)
    self.share_box.css({
      left: 0,
      top: 0,
    })
    return self
  }()
}
